import { render, staticRenderFns } from "./DocumentPrintItemCard.vue?vue&type=template&id=997b9c96&scoped=true"
import script from "./DocumentPrintItemCard.vue?vue&type=script&lang=js"
export * from "./DocumentPrintItemCard.vue?vue&type=script&lang=js"
import style0 from "./DocumentPrintItemCard.vue?vue&type=style&index=0&id=997b9c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997b9c96",
  null
  
)

export default component.exports